import { createContext, CSSProperties, useContext, useEffect, useState } from "react";
import { Colours } from "../Themes/Colours";
import { InterfaceStyles } from "../Components/Interface";

const SiteContext = createContext<{
    windowWidth:number
    styles?:ReturnType<typeof SiteStyles>,
}>({
    windowWidth:0,
});

export const useSite = () => useContext(SiteContext);

export const SiteContextProvider = (props:any) => {

    const [windowWidth, setWindowWidth] = useState(0);
    const [siteStyles, setSiteStyles] = useState<ReturnType<typeof SiteStyles>>(SiteStyles(windowWidth));

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
        setSiteStyles(SiteStyles(window.innerWidth));
    };

    useEffect(()=>{
        window.addEventListener('resize',handleResize);
        handleResize();
        return(()=>{
            window.removeEventListener('resize',handleResize);
        });
    },[]);

    return(
        <SiteContext.Provider {...props} value={{
            windowWidth:windowWidth,
            styles:siteStyles,
        }}></SiteContext.Provider>
    );

};

export const SiteStyles = (width:number) => {
    return {
        landingTitleRow: {
            display:'flex',
            flexDirection:'row',
            width:'100%',
            alignItems:'center',
            justifyContent:'flex-start',
            gap:10,
        } as CSSProperties,
        landingTitleIcon: {
            display:'flex',
            fontSize:32,
            color:Colours.blueHighlightBg,            
            cursor:'default',
        } as CSSProperties,
        landingTitle:{
            display:'flex',
            fontFamily: 'Science Gothic',
            fontSize: width> 600 ? 36 : 24,
            color:Colours.levelFourText,
            textTransform:'uppercase',
        } as CSSProperties,
        revealTitleBlue:{
            color: Colours.blueHighlightBg,
            fontFamily:'Science Gothic',
            fontSize: width> 600 ? 48 : 32,
            textAlign:'center',
            textTransform:'uppercase',
            transition: 'opacity 1s ease',
            transitionDelay:'250ms',
            cursor:'default',
        } as CSSProperties,
        landingNarrowContext:{
            ...InterfaceStyles.standardColumn,
            width:'100%',
            maxWidth:960,
            padding: 40,
            boxSizing:'border-box',
            alignItems:'center',
        } as CSSProperties,
        landingWideContext:{
            ...InterfaceStyles.standardColumn,
            width:'100%',
            boxSizing:'border-box',
            alignItems:'center',
        } as CSSProperties,
        row:{
            display:'flex',
            flexDirection:'row',
        } as CSSProperties,
        rotator:{
            display:'flex',
            width:'100%',
            flexDirection: width > 800 ? 'row' : 'column',
            gap:10,
        } as CSSProperties,
        copyText:{
            display:'flex',
            fontFamily: '"Source Code Pro", monospace',
            fontSize:20,
            color:Colours.levelThreeText,
            textAlign:width > 600 ? 'justify' : 'left',
            cursor:'default',
        } as CSSProperties,
    };
};
